var indentStyle = {"indentZero":"-oJ0G","indentOne":"WnBEd","indentTwo":"bjsf1","indentThree":"ve7kM","indentFour":"CNAfO","indentFive":"_7xp4l","indentSix":"_7B37Q"};

export { indentStyle as i };
//# sourceMappingURL=indentation-a6da70c7.js.map
